import { FlashMessageService } from "zoox-infra";
import { zPayForgotPasswordClientForm } from "zoox-components";
import PersonService from "@/service/person-service";

export default {
  name: "ForgotPasswordDialog",
  components: {
    zPayForgotPasswordClientForm
  },
  props: {
    openDialog: {
      type: Boolean
    },
    companyParams: {
      type: Object,
      default: () => {
        return {};
      }
    },
    personProp: {
      type: Object,
      default: () => {
        return {
          name: "",
          documentTypeId: "",
          documentNumber: "",
          password: "",
          mobileCountryCode: "",
          mobileCityCode: "",
          mobilePhoneNumber: "",
          phoneNumber: "",
          email: "",
          companyId: ""
        };
      }
    }
  },
  data() {
    return {
      success: false,
      personService: new PersonService(),
      person: {
        documentTypeId: this.personProp.documentTypeId,
        documentNumber: this.personProp.documentNumber,
        companyId: this.personProp.companyId
      }
    };
  },
  methods: {
    close() {
      this.$emit("closeForgotPasswordDialog");
    },
    callNewPassword() {
      this.$emit("callNewPasswordDialog");
    },
    forgotPassword(personData) {
      try {
        this.personService.forgotPassword(personData).then(resp => {
          if (resp && resp.passwordToken) {
            FlashMessageService.success(
              this.$t("PAY_FORGOT_PASSWORD.SUCCESS_MESSAGE_TOKEN")
            );
            this.callNewPassword();
          }
        });
      } catch (err) {
        FlashMessageService.error(this.$t("GLOBAL_ERROR.FAILED_REQUEST"));
      }
    }
  }
};
